module.exports = {"540125100":"东嘎镇","540125101":"乃琼镇","540125200":"羊达乡","540125201":"古荣乡","540125202":"柳梧乡","540125203":"马乡","540125204":"德庆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540125.json
// module id = 2488
// module chunks = 0